  <script setup lang="ts">
  import type { DownloadableFile } from '@/types/File'
  import { useFileDownload } from '@/composables/useFileDownload'
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()
  const { downloadFile, isLoading } = useFileDownload()
  const props = defineProps<{ file: DownloadableFile }>()
</script>

<template>
  <a
    href="#"
    data-track="filnedlasting-knapp"
    :class="{ 'disabled': isLoading }"
    :aria-label="t('download.urge', { file: props.file.name})"
    @click.prevent="downloadFile(props.file)"
  >
    <slot />
  </a>
</template>

<style scoped lang="scss">
    a {
      &:focus-visible {
        :deep(.link) {
          @include focus-ring;
        }
      }
    }

    .disabled {
      opacity: .75;
    }
</style>
